module.exports = __webpack_public_path__ + "static/media/redo.a01c1b32.svg";